import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import PostCategoryTable from '@cms/components/tables/post-category-table/post-category-table.vue';

@Component({
  name: 'bpc-post-category',
  components: {
    'bpc-post-category-table': PostCategoryTable,
  },
})
export default class PostCategories extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
